<template>
  <div class="sub-header">
    <h1 class="header">
      <h1  class="d-flex justify-content-center">
        <span  v-on:click="goBack" class="back-icon  cursor-pointer">
          <svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8355 0.482461C12.2638 -0.0892057 11.3422 -0.0892057 10.7705 0.482461L1.0755 10.1775C0.620503 10.6325 0.620503 11.3675 1.0755 11.8225L10.7705 21.5175C11.3422 22.0891 12.2638 22.0891 12.8355 21.5175C13.4072 20.9458 13.4072 20.0241 12.8355 19.4525L4.38884 10.9941L12.8472 2.53579C13.4072 1.97579 13.4072 1.04246 12.8355 0.482461Z" fill="#353535"></path>
          </svg>
         </span>
        <!-- <i v-if="isQuestionPage" :class="['icon-question', 'mr-2 header-icon']"></i> -->

        <h1 class="xxl">
          {{ !isQuestionPage ? resource['hrvenue.InterviewPreparation'] : resource['questionGenerator.pageTitle'] }}
        </h1>
      </h1>
    </h1>
  </div>
</template>

<script>
export default {
  name: 'InterviewHeader',

  components: {},

  props: {
    pageType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    isQuestionPage() {
      return this.pageType === 'question';
    },
  },

  methods: {
    goBack() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.isQuestionPage
        ? this.$router.push({
          name: 'QuestionGeneratorList',
          params: {
            lang,
          },
        })
        : this.$router.push({
          name: 'HrVenueView',
          params: {
            lang,
          },
        });
    },
  },
};
</script>

<style lang="scss">
.back-icon{
  display: flex;
  align-items: center;
  margin-right: 20px;
}
</style>
